<template>
    <div>
        <form @submit.prevent="onSubmit">
            <div class="title-container" v-bind:style="{ background: '#dd3b5f' }">
                <h2 class="search-title">{{ searchboxheadlinerebooking[getCurrentLocale] }}</h2>
                <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p>
                <i class="soap-icon-search"></i>
            </div>

            <section id="content" style="padding-top: 20px; background-color: #fff;">
                <div id="main">
                    <div class="contact-address block" style="margin-left: 20px; margin-right: 20px;">
                        <h4>{{ hellotext1[getCurrentLocale] }}</h4>
                        <br /><p v-html="hellotext2[getCurrentLocale]"></p>

                        <br />

                        <hr>

                        <h5 class="title">{{ when[getCurrentLocale] }}</h5>
                        <div class="row">
                            <div class="col-xs-12">
                                <label>{{ form_field1[getCurrentLocale] }}:* <small></small></label>
                                <input type="text" class="input-text full-width"
                                    :class="{ invalid : $v.input_invoiceid.$error }"
                                    @input="$v.input_invoiceid.$touch()"
                                    v-model="input_invoiceid"
                                    id="'input_invoiceid"
                                    name="input_invoiceid" placeholder="E.G.: 545906" style="text-transform: uppercase;" />
                                <!-- >>> 'errormsg', input_invoiceid -->
                                <p class="errormsg" v-if="$v.input_invoiceid.$dirty && !$v.input_invoiceid.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_invoiceid.$dirty && !$v.input_invoiceid.minLength">{{ errmsg_min_bookingno[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_invoiceid.$dirty && !$v.input_invoiceid.maxLength">{{ errmsg_max_bookingno[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_invoiceid.$dirty && !$v.input_invoiceid.lettersandnumbers">{{ errmsg_lettersandnumbers[getCurrentLocale] }}</p>
                                <!-- <<< 'errormsg', input_flightid1 -->
                            </div>

                        </div>

                        <br />

                        <hr>

                        <!-- >>> Submit -->
                        <a class="button btn-large uppercase full-width silver" v-if="!checkValidity()">{{ rebookflight[getCurrentLocale] }}</a>
                        <button type="submit" class="btn-large icon-check-rebooking uppercase full-width icon-check3" v-if="checkValidity()" v-bind:style="{ background: '#dd3b5f' }">{{ rebookflight[getCurrentLocale] }}</button>
                    </div>
                </div>
            </section>
        </form>
    </div>
</template>

<script>
    import { helpers, required, minLength, maxLength } from 'vuelidate/lib/validators';
    const lettersandnumbers = helpers.regex('lettersandnumbers', /^[A-Za-z0-9]+$/i); /* Validator */

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                searchboxheadlinerebooking: {
                    en: 'Add Infants here',
                    de: 'Kleinkind hinzufügen',
                },
                searchboxheadlineflights2: {
                    en: 'Direct!',
                    de: 'Direkt!',
                },
                hellotext1 : {
                    en: 'Add an Infant',
                    de: 'Fügen Sie ein Kleinkind hinzu',
                },
                hellotext2 : {
                    en: 'Here you can add an infant to an existing flight booking.<br /><br />You can assign the infant to the adult per flight route. This must be the same adult per flight route.<br /><br />If the infant is to be assigned to different adults per flight route, please make two separate bookings.<br /><br /><strong>Note:</strong> You can only add one infant to one adult per booking.',
                    de: 'Hier können Sie zu eine bereits bestehenden Flugbuchung ein Kleinkind hinzufügen.<br /><br />Sie können das Kleinkind pro Flugstrecke dem Erwachsenen zuordnen. Dies muss pro Flugstrecke der gleiche Erwachsene sein.<br /><br />Soll das Kleinkind unterschiedlichen Erwachsenen zugeordnet werden pro Flugstrecke, führen Sie bitte zwei einzelne Buchungen durch.<br /><br /><strong>Hinweis:</strong> Sie können immer nur ein Kleinkind zu einem Erwachsenen pro Buchung hinzufügen.',
                },
                // ----------------------------------
                when: {
                    en: 'Your Invoice id:',
                    de: 'Die Rechnungsnummer:',
                },
                form_field1: {
                    en: 'Invoice (ID)',
                    de: 'Rechnungsnummer',
                },
                form_field2: {
                    en: 'Invoice (ID)',
                    de: 'Rechnungsnummer',
                },
                // ----------------------------------
                rebookflight: {
                    en: 'FIND BOOKING',
                    de: 'BUCHUNG FINDEN',
                },
                // ----------------------------------
                input_invoiceid: '',
                // >>> --------------------------
                errmsg_required: {
                    en: 'This Field must not be empty.',
                    de: 'Dieses Feld darf nicht leer sein.',
                },
                // >>> --------------------------
                errmsg_letterspaces: {
                    en: 'Letters, "-" and spaces are allowed.',
                    de: 'Erlaubt sind Buchstaben, “-“ und Leerzeichen.',
                },
                errmsg_lettersandnumbers: {
                    en: 'Letters and Numberss are allowed.',
                    de: 'Erlaubt sind Buchstaben und Zahlen.',
                },
                // >>> --------------------------
                errmsg_min_bookingno: {
                    en: 'Allowed length: 6-12 characters.',
                    de: 'Erlaubte Länge: 6-12 Zeichen.',
                },
                errmsg_max_bookingno: {
                    en: 'Allowed length: 6-12 characters.',
                    de: 'Erlaubte Länge: 6-12 Zeichen.',
                },
                errmsg_min_birthdate: {
                    en: 'Allowed length: 10 characters.',
                    de: 'Erlaubte Länge: 10 Zeichen.',
                },
                errmsg_max_birthdate: {
                    en: 'Allowed length: 10 characters.',
                    de: 'Erlaubte Länge: 10 Zeichen.',
                },
                // >>> --------------------------
                // currentLocale: 'de',
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Validations */
        validations: {

            input_invoiceid: {
                required: required,
                minLength: minLength(6),
                maxLength: maxLength(8),
                lettersandnumbers: lettersandnumbers
            },

        }, // eo validations{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytoshowbookingforaddinfant'.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> shared/forms/FlighttransferTab.vue >>> created');
            eventBus.$on('readytoshowbookingforaddinfant', this.onEmit_ReadyToShowBookingForAddInfant);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> shared/forms/FlighttransferTab.vue >>> beforeDestroy');
            eventBus.$off('readytoshowbookingforaddinfant', this.onEmit_ReadyToShowBookingForAddInfant);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_getBooking2', // Call:
                'actn_FlagSharedShowFlightSearchResults',
                'actn_FlagSharedShowFlightSearchResults',
                'actn_FlagDirectShowBookingnoSearchResults'

            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc:
            * Note:
            *
            */
            onSubmit: function() {

                let me = this,
                    myParams = {};


                me.$toc('>>> shared/forms/FlighttransferTab.vue >>> onSubmit');
                myParams.idInvoice = this.input_invoiceid.toUpperCase();

                me.actn_FlagSharedShowFlightSearchResults(false); // Hide 'Section'
                me.actn_FlagDirectShowBookingnoSearchResults(false); // Hide 'Section'

                this.actn_call_getBooking2(myParams);

            }, // eo function onSubmit()


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToShowBookingForAddInfant()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_ReadyToShowBookingForAddInfant: function() {

                let me = this,
                    options = {
                        container: 'body',
                        easing: 'linear',
                        offset: -60,
                        force: true,
                        cancelable: true,
                        onStart: function(element) {
                            // scrolling started
                        },
                        onDone: function(element) {
                            // scrolling is done
                        },
                        onCancel: function() {
                            // scrolling has been interrupted
                        },
                        x: false,
                        y: true
                    };


                me.$toc('>>> shared/forms/FlighttransferTab.vue >>> onEmit_ReadyToShowBookingForAddInfant');
                me.actn_FlagDirectShowBookingnoSearchResults(true); // Show 'Section'
                setTimeout(function() {
                    me.$scrollTo('#contentElementDirectBookingno', 200, options);
                }, 300);

            }, // eo function onEmit_ReadyToShowBookingForAddInfant()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * checkValidity()
            *
            * Desc:
            * Note:
            *
            * @param
            * @return {Boolean}
            */
            checkValidity: function() {

                var me = this,
                    formIsValid = false,
                    localStorageAgencyUser = JSON.parse(localStorage.getItem('sdr__agency_username'));


                me.$toc('>>> shared/forms/FlighttransferTab.vue >>> checkValidity');
                // Last Check: Inputs ---------------------
                if (this.input_invoiceid !== '') {
                    if (!me.$v.input_invoiceid.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                } else {
                    formIsValid = false;
                }


                // Agency logged in? ----------------------
                if (formIsValid === true) {
                    if (localStorageAgencyUser === null) {
                        formIsValid = false;
                    }
                }


                return formIsValid;

            }, // eo function checkValidity()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .icon-check-rebooking {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check-rebooking:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #FDB714;
    }

    .errormsg {
        margin-bottom: 3px;
        margin-top: 3px;
        color: red;
    }


    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: "";
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #dd3b5f;
    }
</style>